import React from 'react'
import CountUp from 'react-countup'
import { PrismicRichText } from '@prismicio/react'

const Counter = ({ slice }) => {
  return (
    <section className={`component-${slice.slice_type} relative py-5`}>
      {slice.primary.title.text && (
        <div className='prose prose-lg  max-w-none'>
          <PrismicRichText field={slice.primary.title.richText} />
        </div>
      )}
      {slice.primary.text.text && (
        <div className='prose prose-lg  max-w-none'>
          <PrismicRichText field={slice.primary.text.richText} />
        </div>
      )}
      <dl className='grid grid-cols-2 md:grid-cols-4 gap-4 relative z-10'>
        {slice.items.map((counter, index) => {
          const getDecimal = counter.final_number % 1 !== 0
          const decimals = getDecimal ? 1 : 0
          return (
            <div className='p-4 pb-0 sm:p-8 sm:pb-0' key={`counter-${index}`}>
              <dd>
                <CountUp
                  className='text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-purple-500'
                  delay={slice.primary.delay}
                  decimals={decimals}
                  start={counter.starting_number}
                  end={counter.final_number}
                  suffix={counter.suffix || ''}
                  prefix={counter.prefix || ''}
                  separator=','
                  decimal='.'
                  duration={slice.primary.duration}
                />
              </dd>
              <dt className='text-base text-gray-700'>
                {counter.title.text && (
                  <div className='text-xl font-bold sm:text-2xl'>
                    <PrismicRichText field={counter.title.richText} />
                  </div>
                )}
                {counter.text.text && <PrismicRichText field={counter.text.richText} />}
              </dt>
            </div>
          )
        })}
      </dl>
    </section>
  )
}

export default Counter
